import ContentCopy from '@mui/icons-material/ContentCopy';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import type { BoxProps } from '@mui/system';
import React from 'react';

export const CopyButton = (props: BoxProps & { contentToCopy?: string; }) => {

    const [tooltipOpened, settooltipOpened] = React.useState(false);
    const [timer, setTimer] = React.useState<any>();

    const onCopyClick = () => {
        if (props.contentToCopy) {
            navigator.clipboard.writeText(props.contentToCopy);
            settooltipOpened(true);
            setTimer(setTimeout(() => {
                settooltipOpened(false);
            }, 3000));
        }
    };

    React.useEffect(() => {
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, []);

    return <Tooltip open={tooltipOpened} title="Contenu copié  !">
        <IconButton sx={{ backgroundColor: 'rgba(255,255,255,0.75)' }} onClick={onCopyClick} size='small'><ContentCopy fontSize='small' /></IconButton>
    </Tooltip>;
};
